import React from "react";
import { PageHero } from "../components/site/Shared";
import { Reveal } from "../components/site/Reveal";

const CONTENT = {
  privacy: {
    eyebrow: "Legal",
    title: ["Privacy Policy"],
    lede: "Yadid Advisory treats every inquiry and relationship with discretion. This policy describes, in plain terms, how we handle the information entrusted to us.",
    sections: [
      {
        h: "Information we collect",
        p: "When you contact us, we collect only the information you choose to provide — your name, organization, role, email address, and the note you write. We do not sell or share this information.",
      },
      {
        h: "How we use it",
        p: "We use your information solely to respond thoughtfully to your inquiry and, where a relationship develops, to correspond with you. Submitting an inquiry does not create an advisory relationship.",
      },
      {
        h: "Discretion & retention",
        p: "What is entrusted to us is treated accordingly. We retain inquiry information only as long as necessary to be useful to you, and we protect it with care.",
      },
      {
        h: "Contact",
        p: "For any question about your information, begin a conversation with us and we will respond directly.",
      },
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: ["Terms of Use"],
    lede: "These terms govern your use of the Yadid Advisory website. By using the site, you agree to them.",
    sections: [
      {
        h: "Informational purpose",
        p: "The content on this site is provided for general information about Yadid Advisory and its practices. It does not constitute advice and does not create an advisory or professional relationship.",
      },
      {
        h: "Intellectual property",
        p: "The Yadid name, wordmark, written content, and design are the property of Yadid Advisory LLC and may not be reproduced without permission.",
      },
      {
        h: "No warranties",
        p: "The site is provided as is. While we prepare our content with care, we make no warranties regarding completeness or availability.",
      },
      {
        h: "Governing terms",
        p: "We may update these terms from time to time. Continued use of the site constitutes acceptance of any revisions.",
      },
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const c = CONTENT[kind];
  return (
    <div data-testid={`${kind}-page`}>
      <PageHero eyebrow={c.eyebrow} titleLines={c.title} lede={c.lede} />
      <section className="bg-ivory border-t border-stone">
        <div className="yadid-container max-w-3xl py-16 md:py-24 space-y-14">
          {c.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div>
                <h2 className="font-serif text-2xl md:text-3xl text-ink mb-4">{s.h}</h2>
                <p className="text-lg text-ink/70 font-light leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
